import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

import { Typography } from '@material-ui/core';
import { DSTheme } from '../../../styles/themes/types';

type PropsType = {
  title: string;
  description: string;
  expand?: boolean;
  onClick?: () => void;
};

const useStyles = makeStyles((theme: DSTheme) => ({
  subsection: {
    padding: '32px',
    background: theme.palette.background.elevation2,
    boxShadow: '0px 5px 26px rgba(0, 0, 0, 0.06)',
    borderRadius: '16px',
    marginBottom: '32px',
    cursor: 'pointer',
  },
  content: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    width: '100%',
  },
  hidden: {
    display: 'none',
  },
}));

const DetailsSubsection: React.FC<PropsType> = ({
  title,
  description,
  expand,
  onClick,
  children,
}) => {
  const classes = useStyles();

  return (
    <div className={classes.subsection}>
      <div className={classes.content} onClick={onClick}>
        <div>
          <Typography variant="subtitle1">{title}</Typography>
          <Typography variant="body2">{description}</Typography>
        </div>

        <div>
          <i className="material-icons">{expand ? 'expand_less' : 'expand_more'}</i>
        </div>
      </div>

      <div className={`${expand ? '' : classes.hidden}`}>{children}</div>
    </div>
  );
};

export default DetailsSubsection;
